import { observer } from 'mobx-react'
import React from 'react'
import PaypalSimpleItem from './SimpleItem'

interface IProps {
  method?: any;
  selected?: boolean;
  onChange?: () => void;
}

const PayPalMethodItem: React.FC<IProps> = ({ method, selected, onChange }) => {
  const amount = method?.amount
  return (
    <PaypalSimpleItem selected={selected} amount={amount} onChange={onChange} />
  )
}

export default observer(PayPalMethodItem)
